import { render } from "./VendorBillDetail.vue?vue&type=template&id=9b2f36ce"
import script from "./VendorBillDetail.vue?vue&type=script&lang=js"
export * from "./VendorBillDetail.vue?vue&type=script&lang=js"
script.render = render

export default script